import { render, staticRenderFns } from "./DealDetails.vue?vue&type=template&id=7917fa28&scoped=true"
import script from "./DealDetails.vue?vue&type=script&lang=js"
export * from "./DealDetails.vue?vue&type=script&lang=js"
import style0 from "./DealDetails.vue?vue&type=style&index=0&id=7917fa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7917fa28",
  null
  
)

export default component.exports